<template>
    <div>
        <div v-if="cardsWorking">
            <div class="alert bg-white border col-10 flex-column mx-auto py-2 text-center" v-if="this.errors.length > 0">
                <p class="border-bottom col-6 col-8 mx-auto text-danger">Transaction Failed</p>
                <div class="font-weight-normal pb-4 pt-2 text-dark" v-html="this.errors"></div>
                <button @click="resetPayment" class="btn btn-secondary btn-sm mt-2 mx-auto w-25">OK</button>
            </div>
            <form class="needs-validation border bg-white col-10 py-2 mx-auto" :id="keyString" v-else v-on:submit.prevent="setUpFormData">
                <input type="hidden" name="amount" v-model='amount'>
                <input type="hidden" name="sponsorshipId" v-model='sponsorshipId'>
                <div class="form-group row">
                    <div class="col-md-12 mx-auto text-md-left">
                        <label class="form-text mb-0 moret pb-0 text-lg" for="card_number">Card Number</label>
                        <div class="">
                            <input
                                type="text"
                                v-model="paymentInfo.card_number"
                                name="card_number"
                                id="card_number"
                                class="form-control"
                                maxlength="19"
                                pattern="[0-9\s]{13,19}"
                                required
                                autofocus
                                @input="formatCardNumber"
                            />
                            <small class="text-muted">Enter card number with spaces (e.g., 4111 1111 1111 1111)</small>
                        </div>
                    </div>
                </div>

                <div class="form-group justify-content-center row text-left">
                    <div class="col-4 text-md-left">
                        <label class="form-text mb-0 moret pb-0 text-lg" for="expiration_date">Exp. Date</label>
                        <div class="">
                            <input
                                type="text"
                                class="form-control"
                                id="expiration_date"
                                placeholder="MM/YY"
                                required
                                name="expiration_date"
                                v-model="paymentInfo.expiration"
                                maxlength="5"
                                @input="formatExpirationDate"
                            />
                        </div>
                    </div>
                    <div class="col-3">
                        <label class="form-text mb-0 moret pb-0 text-lg" for="cvv">CVV</label>
                        <input
                            type="text"
                            class="form-control"
                            id="cvv"
                            required
                            name="cvv"
                            v-model="paymentInfo.cvv"
                            maxlength="4"
                            pattern="[0-9]{3,4}"
                        />
                    </div>
                    <div class="col-5">
                        <label class="form-text mb-0 moret pb-0 text-lg" for="zipcode">Zip Code</label>
                        <input
                            type="text"
                            class="form-control"
                            id="zipcode"
                            required
                            name="zipcode"
                            v-model="paymentInfo.zipcode"
                            maxlength="5"
                            pattern="[0-9]{5}"
                        />
                    </div>
                </div>
                <div class="form-group justify-content-center row">
                    <button class="btn btn-primary btn-sm mt-2" type="submit">Submit Payment</button>
                </div>
            </form>
        </div>
        <div v-else>
            <div class="bg-white border col-10 flex-column mx-auto pt-2 pb-4 text-center">
                <p class="border-bottom mx-auto text-capitalize text-lg moret">Sorry for the Inconvenience</p>
                <p class="">Our credit card system is temporarily down for maintenance. Please check back, as it will be up and running shortly!</p>
                <button data-dismiss="modal" class="btn btn-secondary btn-sm mt-2 mx-auto w-25">OK</button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    name: "PaymentTotal",
    props: {
        amount: Number,
        sponsorshipId: String,
        sponsorshipConfirm: String,
        userId: String,
        expenseIds: Array,
        keyString: String
    },
    computed: {
        ...mapState(['errors']),
        cardsWorking() {
            return true
        }
    },
    data(){
        return {
            formData: new FormData(),
            paymentInfo: {
                card_number: '',
                expiration: '',
                cvv: '',
                zipcode: '',
            }
        }
    },
    methods: {
        formatCardNumber(event) {
            let value = event.target.value.replace(/\D/g, '');
            value = value.replace(/(\d{4})/g, '$1 ').trim();
            this.paymentInfo.card_number = value;
        },
        formatExpirationDate(event) {
            let value = event.target.value.replace(/\D/g, '');
            if (value.length >= 2) {
                value = value.slice(0, 2) + '/' + value.slice(2);
            }
            this.paymentInfo.expiration = value;
        },
        setUpFormData() {
            for (var key of this.formData.keys()) {
                this.formData.delete(key)
            }
            this.preparePayment()
        },
        preparePayment() {
            this.formData.append('_method', 'POST')
            this.formData.append('card_number', this.paymentInfo.card_number.replace(/\s/g, ''));
            this.formData.append('expiration_date', this.paymentInfo.expiration);
            this.formData.append('cvv', this.paymentInfo.cvv);
            this.formData.append('zip_code', this.paymentInfo.zipcode);
            this.formData.append('amount', this.amount);
            this.expenseIds.forEach((item) => this.formData.append("expense_ids[]", item))

            const payload = {
                'sponsorship': this.sponsorshipId,
                'paymentData': this.formData
            }
            this.$store.dispatch('sendPayment', payload)
        },
        resetPayment() {
            this.paymentInfo = {
                card_number: '',
                expiration: '',
                cvv: '',
                zipcode: ''
            };
            this.$store.dispatch('clearPayment');
        }
    }
}
</script>
